export default __webpack_public_path__ + "static/media/ARROW_RIGHT.8620c970.png";